<template>
  <header class="admin-header" :class="{ section: isUserLoggedIn }">
    <div class="admin-header-inner">
      <div class="nav-right d-flex align-center mr-2">
        <BreadCrumb :name.sync="breadcrumbName" />
        <div class="profile-menu ml-auto">
          <ul class="pa-0">
            <div class="my-profile pa-0">
              <!-- <router-link
                v-if="user && isUserLoggedIn"
                :to="{ name: 'Profile' }"
              > -->
              <v-layout
                justify-space-around
                align-center
                wrap
                v-if="user && user.firstName"
              >
                <v-avatar
                  v-if="user.media && user.media.length && user.media[0].url"
                  circle
                  size="40"
                >
                  <img :src="user.media[0].url" />
                </v-avatar>
                <v-avatar v-else class="profile-v-avatar">
                  <span class="user-text">{{ user | initial }}</span>
                </v-avatar>
                <strong> {{ user.firstName + " " + user.lastName }} </strong>
              </v-layout>
              <!-- </router-link> -->
              <a v-else @click="login">
                <v-menu offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on">
                      <strong color="#344452" class="headline"
                        >Explore</strong
                      ></v-btn
                    >
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in items"
                      :key="index"
                      :to="{ path: item.path }"
                    >
                      <v-list-item-title class="explore-menus">{{
                        item.title
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-layout wrap color="#344452">
                  <strong color="#344452" class="headline">LOG IN</strong>
                </v-layout>
              </a>
            </div>
          </ul>
        </div>
      </div>
      <v-menu offset-y left v-if="user && isUserLoggedIn">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon color="#6B6B6B" class="vuetify-icon" size="30">
              mdi-chevron-down
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(menu, i) in menuItems"
            :key="i"
            @click="openMenu(menu.id)"
          >
            <v-list-item-title class="menu-title">{{
              menu.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-tooltip
        v-if="user && isUserLoggedIn"
        bottom
        :color="$vuetify.theme.themes.light.tooltipColor"
      >
        <template v-slot:activator="{ on: tooltip, attrs }">
          <v-icon
            color="#344452"
            class="vuetify-icon"
            @click="logout"
            size="30"
            v-bind="attrs"
            v-on="{ ...tooltip }"
            >mdi-logout-variant</v-icon
          >
        </template>
        <span>Logout</span>
      </v-tooltip> -->
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { AuthMixin } from "@/mixins";

export default {
  name: "Header",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb")
  },
  mixins: [AuthMixin],
  data() {
    return {
      items: [
        { title: "News & Articles", path: "/news-feed" },
        { title: "Find Doctor", path: "/find-doctor" }
      ],
      breadcrumbName: "",
      menuItems: [
        { id: 1, title: "Profile" },
        { id: 2, title: "Logout" }
      ]
    };
  },
  watch: {
    $route() {
      this.breadcrumbName = "";
    }
  },
  computed: {
    ...mapGetters("user", {
      isUserLoggedIn: "isUserLoggedIn",
      user: "user"
    })
  },
  methods: {
    showProfile() {
      document.querySelector("#profile-box").classList.toggle("hide");
    },
    login() {
      this.$router.push("/login");
    },
    emitEvent() {
      const index = 2;
      this.$bus.$emit("setActiveId", index);
    },
    async openMenu(id) {
      if (id == 1) {
        this.$router.push("/profile");
      } else {
        this.logout();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.justify-space-around {
  strong {
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 5px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    letter-spacing: 0.75px !important;
    font-size: 16px !important;
    line-height: 28px !important;
    margin-top: 0 !important;
    text-align: center !important;
    color: #434343 !important;
  }
}
.section {
  margin-left: 95px;
}
.avatar-style {
  background-color: rgb(252, 252, 252);
  border: 1px solid #d6e0ef !important;
  border-color: rgb(252, 252, 252);
}
.profile-v-avatar {
  border: 1px solid #d6e0ef !important;
  border-radius: 50% !important;
  background-color: rgb(252, 252, 252) !important;
}
.user-text {
  font-size: 22px;
  color: #000 !important;
  caret-color: #000 !important;
}
.menu-title {
  font-size: 16px;
  font-weight: 400;
  font-family: "Now Alt";
  font-style: normal;
}
</style>
